import React from 'react';
import { Card, CardPrimary, CardTitle, CardSupportingText, CardActions } from 'rmwc/Card';
import { Button } from 'rmwc/Button';
import { Text } from '../../components/Text';

export const ADVISORS = {
  william: {
    name: 'William',
    title: 'Harbor Advisor on Call',
    traits: [
      { name: 'Education', value: 'Harvard' },
      { name: 'Experience', value: '8 years' },
      { name: 'Home State', value: 'Maryland' },
    ],
    avatar: 'avatar-william.jpg',
  },
  nick: {
    name: 'Nick',
    title: 'Independent Advisor',
    traits: [
      { name: 'Education', value: 'U. New Mexico' },
      { name: 'Experience', value: '7 years' },
      { name: 'Home State', value: 'New Mexico' },
    ],
    avatar: 'avatar-nick.jpg',
  },
};

export const Advisor = ({ advisor, hideSchedule, ...other }) => {
  if (!ADVISORS[advisor]) {
    return null;
  }

  const { name, title, traits, avatar } = ADVISORS[advisor];

  return (
    <Card {...other} style={{ width: 350, margin: '1rem auto' }}>
      <div theme="primary-bg" className="px-3 py-2">
        <div theme="on-primary">{title}</div>
      </div>
      <div className="p-3 mt-2 text-left">
        <div className="float-left">
          <Text use="subtitle1">
            <strong>{name}</strong>
          </Text>
          {traits &&
            traits.map(trait => (
              <Text use="body1" className="d-block" key={trait.value}>
                {trait.name}: <strong>{trait.value}</strong>
              </Text>
            ))}
        </div>
        <img className="hrbr-avatar float-right" width={110} height={110} src={require(`images/${avatar}`)} />
      </div>
      {!hideSchedule && (
        <CardActions className="d-block text-center p-3">
          <Button raised theme="secondary-bg on-secondary">
            Schedule
          </Button>
        </CardActions>
      )}
    </Card>
  );
};

export default Advisor;
